import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as uiReducer } from 'redux-ui';
import globalReducers from './components/common/redux/reducers/globalReducers';
import { redirectReducer } from './components/common/redux/reducers/redirectReducer';
import listTableReducer from './components/common/tables/reducers/ListTableReducer';
import userDataReducer from './components/common/user/redux/reducers/UserDataReducer';
import { leftPostalOperatorsReducer } from './components/common/selection-criteria/operator-impc/redux/reducers/LeftOperatorReducer';
import { rightOperatorsReducer } from './components/common/selection-criteria/operator-impc/redux/reducers/RightOperatorReducer';
import { impcsOfSingleOperatorReducer } from './components/common/selection-criteria/impcs-per-operator/redux/reducers/ImpcsOfSingleOperatorReducer';
import rfidFileUploadReducer from './components/application/rfid-file-management/upload/redux/reducer/RfidFileUploadReducer';
import notificationReducer from './components/common/redux/reducers/notificationReducer';
import { globalPresetPerAssetTypeReducer } from './components/common/selection-criteria/global-preset/redux/reducers/GlobalPresetPerAssetTypeReducer';

export default combineReducers({
  routing: routerReducer,
  ui: uiReducer,
  global: globalReducers,
  redirect: redirectReducer,
  listing: listTableReducer,
  userData: userDataReducer,
  left: leftPostalOperatorsReducer,
  right: rightOperatorsReducer,
  impcsOfSingleOperator: impcsOfSingleOperatorReducer,
  rfidFileUpload: rfidFileUploadReducer,
  notification: notificationReducer,
  globalPreset: globalPresetPerAssetTypeReducer,
  // Add your own reducers here
});
